<template>
  <div id="detail_schedule_content_outer" class="row">

    <div style="min-height: 500px;">
      <div v-for="num in 12" :class="[itemCardClass, 'item-card']">
        <match-item-card />
      </div>
      <div style="clear: both;"></div>
    </div>

    <div style="margin-right: 30px;margin-top: 20px;">
      <bottom-paginator
        v-bind:current="paginatorItem.current"
        v-bind:total="paginatorItem.total"
        v-bind:paginator-type="1"
        v-on:itemClicked="paginatorClicked"
      />
    </div>



  </div>
</template>

<script>
import MatchItemCard from "./MatchItemCard";
import BottomPaginator from "../BottomPaginator";
export default {
  name: "MatchDetailScedule",
  components: {
    MatchItemCard,
    BottomPaginator
  },
  data() {
    return {

      itemCardClassType: 0,
      paginatorItem: {
        current: 1,
        total: 8,
      }
    }
  },
  computed: {
    itemCardClass() {
      switch (this.itemCardClassType) {
        case 0:
          return 'item-card-100';
        case 1:
          return 'item-card-50'
        case 2:
          return 'item-card-33'
        default:
          return 'item-card-25'
      }
    }
  },
  mounted() {

    this.updateStatus();
    $(window).resize(this.updateStatus);
  },
  methods: {
    updateStatus() {
      let width = $('#detail_schedule_content_outer').width();
      // console.log('hhh');
      // console.log(width);
      if (width >= 1160) {
        this.itemCardClassType = 3;
      } else if (width >= 870) {
        this.itemCardClassType = 2
      } else if (width >= 580) {
        this.itemCardClassType = 1;
      } else {
        this.itemCardClassType = 0;
      }
    },
    paginatorClicked(event) {
      let index = event.index;
      this.paginatorItem.current = index;
    },
  }
}
</script>

<style scoped>

  #detail_schedule_content_outer {
    border: solid 1px #fc1a34;
    min-height: 200px;
    margin-top: 30px;
    padding-top: 15px;
    padding-bottom: 30px;
  }

  #detail_schedule_content_outer .item-card {
    padding: 15px;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: center;
    justify-content: center;
    float: left;
    margin-left: 0;
  }

  #detail_schedule_content_outer .item-card-25 {
    width: 25%;
  }

  #detail_schedule_content_outer .item-card-33 {
    width: 33.33%
  }

  #detail_schedule_content_outer .item-card-50 {
    width: 50%
  }

  #detail_schedule_content_outer .item-card-100 {
    width: 100%
  }

</style>



// WEBPACK FOOTER //
// src/components/matches/MatchDetailScedule.vue